'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _events = require('redux/modules/events');

var _components = require('../components');

var _connectData = require('helpers/connectData');

var _connectData2 = _interopRequireDefault(_connectData);

var _querystring = require('querystring');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchData(getState, dispatch, location) {
  var promises = [];
  var map = getState().events.map;

  if (location.query.range) {
    var range = location.query.range.split(',').map(function (time) {
      return (0, _moment2.default)(time);
    });

    if (range.length) {
      var start = range[0] ? range[0].format('YYYY-MM-DD HH:mm:ss') : null;
      var end = range[1] ? range[1].format('YYYY-MM-DD HH:mm:ss') : null;
      promises.push(dispatch((0, _events.selectRange)({ start: start, end: end })));
    }
  }

  var centerLat = map.centerLat,
      centerLng = map.centerLng,
      radius = map.radius;

  var query = {
    distance: centerLat + ',' + centerLng + ',' + radius,
    order: 'start_date',
    recurrences: false
  };

  // force reload events with back and next browser buttons
  promises.push(dispatch((0, _events.index)(location.search === '' ? '?' + (0, _querystring.stringify)(query) : location.search + (0, _querystring.stringify)(query))));

  return _promise2.default.all(promises);
}

var EventsMapContainer = (_dec = (0, _connectData2.default)(fetchData), _dec(_class = function (_Component) {
  (0, _inherits3.default)(EventsMapContainer, _Component);

  function EventsMapContainer() {
    (0, _classCallCheck3.default)(this, EventsMapContainer);
    return (0, _possibleConstructorReturn3.default)(this, (EventsMapContainer.__proto__ || (0, _getPrototypeOf2.default)(EventsMapContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(EventsMapContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_components.EventsMap, null);
    }
  }]);
  return EventsMapContainer;
}(_react.Component)) || _class);
exports.default = EventsMapContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/EventsMapContainer.js
// module id = 1181
// module chunks = 0